// extracted by mini-css-extract-plugin
export default {"container":"addManufacturers_container__g0r63","assignAll":"addManufacturers_assignAll__SlME5","manufacturers":"addManufacturers_manufacturers__J7eOh"};